import FloatingInput from "../fields/FloatingInput";

interface StepSavMessageProps {
  value: string;
  onChange: (name: string, value: string) => void;
}

export default function StepSavMessage({
  value,
  onChange,
}: StepSavMessageProps) {
  return (
    <fieldset style={{ border: "none" }}>
      <legend
        style={{
          fontSize: 16,
          fontWeight: 500,
          marginBottom: 12,
          display: "block",
          width: "100%",
        }}
      >
        Merci de décrire votre demande
      </legend>
      <FloatingInput
        name="savMessage"
        label="Votre commentaire"
        value={value}
        onChange={onChange}
        isTextarea
        rows={4}
        maxLength={2000}
      />
    </fieldset>
  );
}
